export default "__VITE_PUBLIC_ASSET__7faf8d9e__"